import { languageEnglish } from './languageEnglish';
import { languageFrench } from './languageFrench';
import { languageItalian } from './languageItalian';

import type { TranslationMessages } from './translationMessages';

export const getMessages = (locale: string): TranslationMessages => {
  switch (locale) {
    case 'en':
      return languageEnglish;
    case 'fr':
      return languageFrench;
    case 'it':
      return languageItalian;
    default:
      return languageEnglish;
  }
};
